import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export default function AccountReset() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/account/reset-password", { token, password });
      toast.success("Password updated — sign in with your new password");
      navigate("/account/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="pt-32 pb-24 px-5 bg-cream min-h-screen" data-testid="account-reset-page">
      <div className="max-w-md mx-auto">
        <h1 className="font-serif-display uppercase text-plum-deep text-4xl sm:text-5xl text-center mb-8">CHOOSE A NEW PASSWORD</h1>
        <form onSubmit={submit} className="bg-warmwhite border-[3px] border-plum-deep rounded-[2rem] p-6 md:p-8 space-y-3">
          <input required type="password" minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (8+ characters) *" data-testid="reset-password-input"
            className="w-full rounded-full px-5 py-3 bg-cream border-2 border-plum-deep/15 text-sm focus:outline-none focus:border-magenta" />
          <input required type="password" minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password *" data-testid="reset-confirm-input"
            className="w-full rounded-full px-5 py-3 bg-cream border-2 border-plum-deep/15 text-sm focus:outline-none focus:border-magenta" />
          <button type="submit" disabled={busy || !token} data-testid="reset-submit-btn"
            className="w-full rounded-full bg-magenta text-cream py-3.5 font-serif-display uppercase text-sm tracking-[0.16em] font-bold hover:bg-plum transition-colors disabled:opacity-50">
            {busy ? "SAVING…" : "SAVE NEW PASSWORD"}
          </button>
          {!token && <p className="text-xs text-center text-orange">This link is missing its token — <Link to="/account/login" className="underline">request a new one</Link>.</p>}
        </form>
      </div>
    </div>
  );
}
